import React, { useContext, useEffect, useState } from "react";
import { Button } from "primereact/button";
import { authenticationService } from "../../services/AuthenticationService";
import { delimitationService } from "../../services/DelimitationService";
import DropDown from "../../componets/DropDown";
import { AppDB } from "../../App";
import { changeLang } from "../../componets/Language/ChangeLang";
import styles from "./user-delimitation.scss";
import { SelectButton } from "primereact/selectbutton";
import { ToggleButton } from "primereact/togglebutton";
import { Checkbox } from "primereact/checkbox";
export class ApplicationQuery {
	constructor(
		pageIndex = 1,
		pageSize = 10,
		statusID = [],
		districtID = [],
		constituencyID = [],
		pollingDivisionID = [],
		registrationCentreID = []
	) {
		this.pageIndex = pageIndex;
		this.pageSize = pageSize;
		this.applicationTypeID = 1;
		this.applicationStatusID = statusID;
		this.districtID = districtID;
		this.constituencyID = constituencyID;
		this.pollingDivisionID = pollingDivisionID;
		this.registrationCentreID = registrationCentreID;

	}
}

export const UserDelimitation = ({
	makeDashboardTrigger,
	onDelimitationChanged = () => { },
	setvillageSelected = () => {},
	isExteral,
	showCorrectionVillage=false,
	showVillage = false,
	showFilter = false,
	forceFilter = false,
	isReport = false,
	isNationalElectionReport = false,
	onDelimitationChangedWithAllParamters = () => { },
	midGridBlock = 3,
	isPoliticalParty = false,
	politicalDelimitation = {},
	dermacationForm,
	setdermacationForm,
	hideVillageID=null,
	returnedApplication = false
}) => {
	const [districts, setDistricts] = useState([]);
	const [constituencies, setConstituencies] = useState([]);
	const [pollingDivisions, setPollingDivisions] = useState([]);
	const [registrationCentres, setRegistrationCentres] = useState([]);
	const [villages, setVillages] = useState([]);
	const [districtsLoading, setDistrictsLoading] = useState(false);
	const [constituenciesLoading, setConstituenciesLoading] = useState(false);
	const [villageLoading, setVillageLoading] = useState(false);
	const [pollingDivisionsLoading, setPollingDivisionsLoading] = useState(false);
	const [registrationCentresLoading, setRegistrationCentresLoading] = useState(false);
	const [district, setDistrict] = useState("");
	const [constituency, setConstituency] = useState("");
	const [pollingDivision, setPollingDivision] = useState("");
	const [registrationCentre, setRegistrationCentre] = useState("");
	const [village, setVillage] = useState("");
	const [level, setLevel] = useState(1);
	const [update, setUpdate] = useState(true);
	const { setGlobalDelimitation, globalDelimitation,officeOnly,setOfficeOnly,isOfficeView,setIsOfficeView } = useContext(AppDB);

	const onDistrictChanged = (e) => {
		setDistrict(e.value);
		setConstituencies([]);
		setConstituency("");
		getConstituencies(e.value);
		if (isReport) {
			setVillage("");
			setVillages([]);
		}
	};

	const onConstituencyChanged = (e) => {
		setConstituency(e.value);
		getPollingDivisions(e.value);
	};

	const onPollingDivisionChanged = (e) => {
		setPollingDivision(e.value);
		getRegistrationCentres(e.value);
	};

	const onRegistrationCentreChanged = (e) => {
		setRegistrationCentre(e.value);
		if (showVillage) {
			getVillageByRegistrationCentres(e.value);
		}
	};

	const onVillageChanged = (e) => {
		setVillage(e.value);
		if(showVillage && showCorrectionVillage){
			setvillageSelected(e?.value)
		}
		
	};

	useEffect(() => {
		if (forceFilter) {
			setUpdate(false);
			setTimeout(() => {
				setUpdate(true);
			}, 200);
		}
	}, [district, constituency, pollingDivision, registrationCentre, village]);
	useEffect(()=>{
		if (district) {
			getConstituencies(district);
		}
	},[district])
function syncForm(district, constituency, pollingDivision, registrationCentre, village) {
    if (!setdermacationForm) return;

    setdermacationForm(prev => ({
        ...prev,
        districtID: district,
        constituencyID: constituency,
        pollingDivisionID: pollingDivision,
        registrationCentreID: registrationCentre,
        villageID: village
    }));
}

	function getConstituencies(districtID) {

		try {

			if (isPoliticalParty === false) {
				var districts = authenticationService.getDelimitation();
				var district = districts.find((o) => o.id === districtID);
			} else {
				//so it can enter the constituencies level
				// 078137943486
				var district = {
					constituencies: []
				}
			}

			// console.log(districts)
			if (isPoliticalParty === true || districts.length > 0) {

				setPollingDivision("");
				setPollingDivisions([]);
				setRegistrationCentre("");
				setRegistrationCentres([]);

				//check if user have constituency(Level2). If not then get all constituencies
				//of the user district(Leve1)
				if (district.constituencies.length === 0) {
					setConstituenciesLoading(true);
					setLevel(1);
					delimitationService.getConstituenciesByDistrict(districtID).then((data) => {
						setConstituenciesLoading(false);

						var list = [];

						data.forEach((item) => {
							list.push({ id: item.id, name: `${item.code} - ${item.name}` });
						});

						setConstituencies(list);
					});
				} else {
					setConstituencies(district.constituencies);
					setConstituency(district.constituencies[0].id);
					getPollingDivisions(district.constituencies[0].id);
					setLevel(2);
				}
			} else {
				setConstituencies([]);
				setConstituency("");
				setPollingDivision("");
				setPollingDivisions([]);
				setRegistrationCentre("");
				setRegistrationCentres([]);
			}
		} catch (error) {

		}

	}

	function getPollingDivisions(constituencyID) {
		try {
			setPollingDivisionsLoading(true);
			delimitationService.getPollingDivisionsByConstituency(constituencyID).then((data) => {
				var list = [];

				data.forEach((item) => {
					list.push({ id: item.id, name: `${item.code} - ${item.name}` });
				});

				setPollingDivisionsLoading(false);
				setPollingDivisions(list);
				setPollingDivision("");
				setRegistrationCentre("");
				setRegistrationCentres([]);
			});
		} catch (error) {
			console.log(error);
		}
	}

	function getRegistrationCentres(pollingDivisionID) {
		try {
			setRegistrationCentresLoading(true);
			setRegistrationCentres([]);
			setRegistrationCentre("");

			delimitationService.getRegistrationCentresByPollingDivision(pollingDivisionID).then((data) => {
				var list = [];
				data.forEach((item) => {
					list.push({ id: item.id, name: `${item.code} - ${item.name}` });
				});
				setRegistrationCentresLoading(false);
				setRegistrationCentres(list);
				setRegistrationCentre("");
			});
		} catch (error) {
			console.log(error);
		}
	}

	function getVillageByRegistrationCentres(RegistrationCenterID) {
		try {
			setVillageLoading(true);
			setVillage("");
			setVillages([]);
			delimitationService.getVillagesByRegistrationCentre(RegistrationCenterID).then((data) => {
				var list = [];
				data.forEach((item) => {
					list.push({ id: item.id, name: `${item.code} - ${item.name}` });
				});
				setVillageLoading(false);
				setVillages(list);
			});
		} catch (error) {
			console.log(error);
		}
	}

	function onApplyFilter() {
		setUpdate(true);
	}

	function onClearFilter() {
		if (level === 1) {
			setConstituency("");
		}

		setPollingDivision("");
		setRegistrationCentre("");
		setVillage("");
		setUpdate(true);
		if (isReport && isNationalElectionReport) {
			setDistrict("");
		}
	}

	function raiseChangedEvent() {
		var delimitationLevelID = 1;
		var delimitationID = district;

		if (constituency !== "" && pollingDivision === "" && registrationCentre === "") {
			delimitationLevelID = 2;
			delimitationID = constituency;
		} else if (pollingDivision !== "" && registrationCentre === "") {
			delimitationLevelID = 3;
			delimitationID = pollingDivision;
		} else if (registrationCentre !== "" && showVillage == false) {
			delimitationLevelID = 4;
			delimitationID = registrationCentre;
		} else if (village !== "") {
			delimitationLevelID = 5;
			delimitationID = village;
		}
		onDelimitationChanged({ delimitationID, delimitationLevelID });

		setUpdate(false);
	}

	function raiseReportChangedEvent() {
		var delimitationLevelID = 1;
		var delimitationID = district;

		if (village !== "") {
			delimitationLevelID = 5;
			delimitationID = village;
		} else if (registrationCentre !== "") {
			delimitationLevelID = 4;
			delimitationID = registrationCentre;
		} else if (pollingDivision !== "" && registrationCentre === "") {
			delimitationLevelID = 3;
			delimitationID = pollingDivision;
		} else if (constituency !== "" && pollingDivision === "" && registrationCentre === "") {
			delimitationLevelID = 2;
			delimitationID = constituency;
		}

		onDelimitationChanged({ delimitationID, delimitationLevelID });

		setUpdate(false);
	}

	useEffect(() => {
    if (isReport) {
        raiseReportChangedEvent();
    }
    setUpdate(false);

    syncForm(district, constituency, pollingDivision, registrationCentre, village); // << ADD THIS

    onDelimitationChangedWithAllParamters({ district, constituency, pollingDivision, registrationCentre, village });
}, [district, constituency, pollingDivision, registrationCentre, village]);


	useEffect(() => {
		if (update === true) {
			raiseChangedEvent();
		}
		if (isExteral === true) {
			setGlobalDelimitation({
				...globalDelimitation,
				district,
				districts,
				registrationCentre,
				registrationCentres,
				constituencies,
				constituency,
				pollingDivision,
				pollingDivisions
			});
		}
	}, [district, constituency, pollingDivision, registrationCentre, update]);

	useEffect(() => {
		async function loader() {
			//


			if (isPoliticalParty === false) {
				var delimitation = authenticationService.getDelimitation();
			} else {
				var dist = await delimitationService.getDistricts()
				setDistricts(dist)

				if (![null, undefined, ""].includes(politicalDelimitation?.districtID)) {
					var consti = await delimitationService.getConstituenciesByDistrict(politicalDelimitation.districtID)
					setConstituencies(consti)
					setDistrict(politicalDelimitation.districtID)
				}



				if (![null, undefined, ""].includes(politicalDelimitation?.constituencyID)) {
					var pol = await delimitationService.getPollingDivisionsByConstituency(politicalDelimitation.constituencyID)
					await setPollingDivisions(pol)
					setConstituency(politicalDelimitation.constituencyID)
				}

				if (![null, undefined, ""].includes(politicalDelimitation?.pollingDivisionID)) {
					var regCenter = await delimitationService.getRegistrationCentresByPollingDivision(politicalDelimitation.pollingDivisionID)
					await setRegistrationCentres(regCenter)
					setPollingDivision(politicalDelimitation.pollingDivisionID)
				}

				if (![null, undefined, ""].includes(politicalDelimitation?.registrationCentreID)) {
					setRegistrationCentre(politicalDelimitation.registrationCentreID)

				}


				// var pol = await delimitationService.getPollingDivisionsByConstituency()
				// var regCenter = await delimitationService.getRegistrationCentresByPollingDivision()
				// await setDistricts(dist);
				// await setConstituencies(consti)
				// await setPollingDivisions(pol)
				// await setRegistrationCentres(regCenter)
				console.log(politicalDelimitation)

				// setDistrict()
				// setConstituencies()
				// setPollingDivision()
				// var delimitation = await delimitationService.getVillagesByRegistrationCentre()
			}

			// console.log(delimitation.districts)

			//which means this is coming from dashboard;
			if (globalDelimitation?.district) {
				setDistricts(globalDelimitation?.districts);
				setDistrict(globalDelimitation?.district);
				setConstituencies(globalDelimitation?.constituencies);
				setConstituency(globalDelimitation?.constituency);
				setPollingDivisions(globalDelimitation?.pollingDivisions);
				setPollingDivision(globalDelimitation?.pollingDivision);
				setRegistrationCentres(globalDelimitation?.registrationCentres);
				setRegistrationCentre(globalDelimitation?.registrationCentre);
			} else {
				if (isPoliticalParty === false) {
					await setDistricts(delimitation);
					if (delimitation.length > 0) {
						setDistrict(delimitation[0].id);
						await getConstituencies(delimitation[0].id);
						setUpdate(true);
					}
				}
			}
		}
		loader()
	}, []);

	useEffect(() => {
		if (makeDashboardTrigger === true) {
			onApplyFilter();
		}
	}, [makeDashboardTrigger]);

	function map_delimitation_code_and_name(obj = [],hideVillageID) {
		obj.sort((a, b) => Number(a?.code) - Number(b?.code));
		const filteredList = obj.filter(item => item.id !== hideVillageID);
		return filteredList;
	}

	useEffect(() => {
  if (returnedApplication) {
    setIsOfficeView(true);
  }
}, [returnedApplication]);

const [selectedView, setSelectedView] = useState("office");

	const viewOptions = [
	{ label: "Office View", value: "office" },
	{ label: "Delimitation View", value: "delimitation" }
	];


	return (
		<div>
			{returnedApplication && (
				<div class="grid">
					<div class="lg:col-6 md:col-6 col-12">
						<div class="text-center  border-round-sm bg-none font-bold">
							<DropDown
								value={selectedView}
								onChange={(e) => {
									setSelectedView(e.value);

									if (e.value === "office") {
										setOfficeOnly(true);
										setIsOfficeView(true);
										// Clear delimitation dropdowns
										setConstituency("");
										setPollingDivision("");
										setRegistrationCentre("");
										setVillage("");
									} else if (e.value === "delimitation") {
										setIsOfficeView(false);
										setOfficeOnly(false); // disable Office Only
									}
								}}
								options={viewOptions}
								optionLabel="label"
								placeholder="Select View"
								className="w-full"
							/>
						</div>
					</div>
					<div class="lg:col-6 md:col-6  col-12">
						{isOfficeView && (
							<div class="text-start border-round-sm p-1 bg-none">
								<Checkbox id="officeOnly" checked={officeOnly} onChange={() => setOfficeOnly(!officeOnly)} />
								<label htmlFor="officeOnly" className="text-md ml-2">
									My Applications Only
								</label>
							</div>
						)}
					</div>
				</div>
			)}

			{!returnedApplication && (
				<div className={`${!showVillage && "mt-2"} p-fluid grid`}>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.district")}
							value={district}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(districts)}
							onChange={onDistrictChanged}
							loading={districtsLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.constituency")}
							value={constituency}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(constituencies)}
							onChange={onConstituencyChanged}
							loading={constituenciesLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.votingCentre")}
							value={pollingDivision}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(pollingDivisions)}
							onChange={onPollingDivisionChanged}
							loading={pollingDivisionsLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.votingStation")}
							value={registrationCentre}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(registrationCentres)}
							onChange={onRegistrationCentreChanged}
							loading={registrationCentresLoading}
						/>
					</div>
					{showVillage && (
						<div className={`col-12 md:col-${midGridBlock}`}>
							<DropDown
								label={changeLang.get("national_delimitation.village")}
								value={village}
								optionLabel="name"
								optionValue="id"
								options={map_delimitation_code_and_name(villages, hideVillageID)}
								onChange={onVillageChanged}
								loading={villageLoading}
							/>
						</div>
					)}
				</div>
			)}
			{returnedApplication && selectedView !== "office" && (
				<div className={`${!showVillage && "mt-2"} p-fluid grid`}>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.district")}
							value={district}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(districts)}
							onChange={onDistrictChanged}
							loading={districtsLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.constituency")}
							value={constituency}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(constituencies)}
							onChange={onConstituencyChanged}
							loading={constituenciesLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.votingCentre")}
							value={pollingDivision}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(pollingDivisions)}
							onChange={onPollingDivisionChanged}
							loading={pollingDivisionsLoading}
						/>
					</div>
					<div className={`col-12 md:col-${midGridBlock}`}>
						<DropDown
							label={changeLang.get("national_delimitation.votingStation")}
							value={registrationCentre}
							optionLabel="name"
							optionValue="id"
							options={map_delimitation_code_and_name(registrationCentres)}
							onChange={onRegistrationCentreChanged}
							loading={registrationCentresLoading}
						/>
					</div>
					{showVillage && (
						<div className={`col-12 md:col-${midGridBlock}`}>
							<DropDown
								label={changeLang.get("national_delimitation.village")}
								value={village}
								optionLabel="name"
								optionValue="id"
								options={map_delimitation_code_and_name(villages, hideVillageID)}
								onChange={onVillageChanged}
								loading={villageLoading}
							/>
						</div>
					)}
				</div>
			)}
			{showFilter && (
				<>
					{!isNationalElectionReport && (
						<Button label="Apply" onClick={onApplyFilter} className="mt-4 mr-2 p-button-primary" size="small" disabled={update} />
					)}
					<Button label="Clear" onClick={onClearFilter} className="mt-4 p-button-primary" size="small" />
				</>
			)}
		</div>
	);
};
